






































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DetailsDialog from "../Dialogs/DetailsDialog.vue";
import EditDialog from "../Edit/EditDialog.vue";
import CreateDialog from "../Dialogs/CreateDialog.vue";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import CandidatureProposteLavoroDialog from "../Dialogs/CandidatureProposteLavoroDialog.vue";

@Component({
	components: {
		DetailsDialog,
		EditDialog,
		CreateDialog,
		CandidatureProposteLavoroDialog
	}
})
export default class JobsDataTable extends Vue {
	@Prop() params!: any;
	@Prop() createDialogParams!: object;
	@Prop() candidatureDialogParams!: object;
	private search: string;
	private loadingData: boolean;

	private articolazioni: any;
	private articolazioneFilter: string;

	private showDetailDialog: boolean;

	constructor() {
		super();
		this.search = "";
		this.loadingData = true;
		this.articolazioni = this.params.listaArticolazioni;
		this.articolazioneFilter = "Tutte";
		this.showDetailDialog = true;
	}

	@Watch("articolazioneFilter")
	onArticolazioneChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	filterChange() {
		var filters = {
			fitroArticolazione: ""
		};
		if (this.params.filterType === "listaOfferteAllievo") {
			filters = {
				fitroArticolazione: this.articolazioneFilter
			};
			bus.$emit("filtroOfferteAllievi", filters);
		}
		if (this.params.filterType === "listaOfferteIstituto") {
			filters = {
				fitroArticolazione: this.articolazioneFilter
			};
			bus.$emit("filtroOfferteIstituto", filters);
		}
	}

	sendCandidatura(item: any) {
		var studentInfo = user.readStudentInfo(this["$store"]);
		var allievo = studentInfo.cognomeUtente + " " + studentInfo.nomeUtente;
		var currentDate = new Date().toISOString().substr(0, 10);
		var payload = {
			idProposta: item.idProposta,
			idAllievo: studentInfo.idUtente,
			dataCandidatura: currentDate
		};
		user
			.dispatchCreaCandidaturaLavoro(this["$store"], payload)
			.then(() => {
				var payload2 = {
					emailContatto: item.emailContattoAzienda,
					allievo: allievo,
					istituto: studentInfo.entità,
					nomeProposta: item.nomeProposta
				};
				user
					.dispatchSendCandidaturaLavoro(this["$store"], payload2)
					.then(() => {
						bus.$emit(
							"successfullOperation",
							"Candidatura inviata con successo"
						);
						bus.$emit("loadProposte");
					})
					.catch(error => {
						if (error.response.status === 403) {
							bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							this["$router"].push("/login");
						} else {
							bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						}
					});
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	cancelCandidatura(item: any) {
		var payload = {
			idCandidatura: item.idCandidatura
		};
		if (confirm("Cancellare la propria candidatura?")) {
			user
				.dispatchDeleteCandidatura(this["$store"], payload)
				.then(() => {
					bus.$emit(
						"successfullOperation",
						"Candidatura cancellata con successo"
					);
					bus.$emit("loadProposte");
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					}
				});
		}
	}

	deleteProposta(item: any) {
		var payload = {
			idProposta: item.idProposta
		};
		if (confirm("Cancellare la proposta di lavoro?")) {
			user
				.dispatchDeleteProposta(this["$store"], payload)
				.then(() => {
					bus.$emit("successfullOperation", "Proposta cancellata con successo");
					bus.$emit("loadProposte");
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					}
				});
		}
	}

	created() {
		bus.$on("dataLoaded", () => {
			this.loadingData = false;
		});

		bus.$on("destroyDetailDialog", async () => {
			this.showDetailDialog = false;
			await this.$nextTick();
			this.showDetailDialog = true;
		});
	}
}
